import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { ListPrice as ListPriceType } from 'typings'
import { useDrawerState, useFormStateContext } from '../../../..'
import { IconListPrice } from '../../../../icons/IconListPrice'
import { useConditions } from '../useConditions'
import { ListPriceEditor } from './Editor'
import { ListPriceView } from './View'
import { messages } from './messages'

interface Props {
  name: string
}

export type ListPriceConfig = ListPriceType

export function ListPrice(props: Props) {
  const { name } = props
  const { $t } = useIntl()

  const { form } = useFormStateContext()
  const config: ListPriceConfig = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.title),
    icon: <IconListPrice />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: ListPriceConfig) => form.setValue(name, values)

  return (
    <>
      <ListPriceView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <ListPriceEditor
        state={editorState}
        initialConfig={config}
        onSave={handleSave}
      />
    </>
  )
}
